import featureToggle, { STOCK_REVAMP } from '@config/featureToggle';
import { TYPE_BUY, TYPE_SELL } from 'Component/__deprecated__/StockActionV2/constants';

// TODO: REMOVE IF BUY/SELL STOCK REVAMP is GOOD TO RELEASE
export default function useStockFeatureToggle() {
  const featStockRevamp = featureToggle.some(
    feat => feat.feature === STOCK_REVAMP && feat.toggle
  );
  const popupTypeBuy = featStockRevamp ? TYPE_BUY : 'buy';
  const popupTypeSell = featStockRevamp ? TYPE_SELL : 'sell';
  
  return {
    featStockRevamp,
    popupTypeBuy,
    popupTypeSell,
  };
}
